export default __webpack_public_path__ + "static/sophisticated_elegance-e782163616e2dcf13b1a408eb924eae0.png";